import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./sitePages.css";
import "./services.css";

import appDevImg from "./Images/Telephone.jpg";
import webAppImg from "./Images/gbtP6.jpg";
import websiteImg from "./Images/gbtP3.jpg";
import networkImg from "./Images/gbtP5.jpg";
import softwareImg from "./Images/Fourniture_IT_bureautique.avif";

function Services({ embedded = false }) {
  const NavAction = ({ to, anchor, children }) =>
    embedded ? <a href={anchor}>{children}</a> : <Link to={to}>{children}</Link>;

  return (
    <div className="content-page">
      {!embedded && <Header />}

      <main className="content-main">
        <section className="page-hero">
          <h1>Nos solutions</h1>
          <p>
            Une offre structur&eacute;e autour de la digitalisation, de
            l&apos;infrastructure IT et de l&apos;approvisionnement bureautique.
          </p>
        </section>

        <section className="solutions-grid">
          <article className="solution-card">
            <h2>Digitalisation</h2>
            <ul>
              <li>Sites web</li>
              <li>Applications</li>
              <li>Automatisation</li>
              <li>Smart-Educka</li>
            </ul>
          </article>

          <article className="solution-card">
            <h2>Infrastructure IT</h2>
            <ul>
              <li>Mat&eacute;riel</li>
              <li>R&eacute;seaux</li>
              <li>S&eacute;curit&eacute;</li>
              <li>Maintenance</li>
            </ul>
          </article>

          <article className="solution-card">
            <h2>Approvisionnement bureautique</h2>
            <ul>
              <li>Fournitures</li>
              <li>Consommables</li>
              <li>Gestion des commandes</li>
            </ul>
          </article>
        </section>

        <section className="content-block links-row">
          <NavAction to="/solutions-ecoles" anchor="#solutions-ecoles">
            Voir les solutions pour écoles
          </NavAction>
          <NavAction to="/solutions-pme" anchor="#solutions-pme">
            Voir les solutions pour PME
          </NavAction>
          <NavAction to="/contact" anchor="#contact">
            Demander un audit gratuit
          </NavAction>
        </section>

        <section className="legacy-services-header">
          <h2>Expertise d&eacute;taill&eacute;e</h2>
          <p>
            Les services historiques de SAMOL TECHNOLOGIES sont conserv&eacute;s
            et int&eacute;gr&eacute;s dans la nouvelle architecture.
          </p>
        </section>

        <section className="legacy-services">
          <div className="service-item">
            <img src={appDevImg} alt="Application Development" />
            <div className="service-text">
              <h3>D&eacute;veloppement d&apos;applications mobiles</h3>
              <p>
                Nous sommes sp&eacute;cialis&eacute;s dans le d&eacute;veloppement
                d&apos;applications mobiles iOS et Android pour des besoins
                m&eacute;tier sp&eacute;cifiques.
              </p>
              <ul>
                <li>Exp&eacute;rience utilisateur adapt&eacute;e</li>
                <li>Conception centr&eacute;e utilisateur</li>
                <li>Int&eacute;gration de technologies modernes</li>
                <li>Support et maintenance continus</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <img src={webAppImg} alt="Web Application Development" />
            <div className="service-text">
              <h3>D&eacute;veloppement d&apos;applications web</h3>
              <p>
                Nous cr&eacute;ons des applications web sur mesure avec un
                accent sur la performance, la s&eacute;curit&eacute; et la
                facilit&eacute; d&apos;usage.
              </p>
              <ul>
                <li>Conception personnalis&eacute;e</li>
                <li>Performances &eacute;lev&eacute;es</li>
                <li>Compatibilit&eacute; multiplateforme</li>
                <li>S&eacute;curit&eacute; renforc&eacute;e</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <img src={websiteImg} alt="Website Design" />
            <div className="service-text">
              <h3>Conception de sites web</h3>
              <p>
                Nous concevons des sites web vitrines et e-commerce responsives
                pour les entreprises de toutes tailles.
              </p>
              <ul>
                <li>Sites web responsives</li>
                <li>Optimisation SEO</li>
                <li>Int&eacute;gration r&eacute;seaux sociaux</li>
                <li>Analyse de l&apos;exp&eacute;rience utilisateur</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <img src={networkImg} alt="Network Installation and Configuration" />
            <div className="service-text">
              <h3>Installation et configuration de r&eacute;seaux d&apos;entreprise</h3>
              <p>
                Nous assurons installation, configuration et support pour
                garantir une connectivit&eacute; stable et s&eacute;curis&eacute;e.
              </p>
              <ul>
                <li>Installation LAN et WAN</li>
                <li>S&eacute;curit&eacute; r&eacute;seau renforc&eacute;e</li>
                <li>Support continu</li>
                <li>Formation utilisateur</li>
              </ul>
            </div>
          </div>

          <div className="service-item">
            <img src={softwareImg} alt="Fourniture de bureau" />
            <div className="service-text">
              <h3>Fourniture de bureau</h3>
              <p>
                Nous proposons une gamme compl&egrave;te de fournitures de
                bureau pour &eacute;quiper vos &eacute;quipes au quotidien avec
                des produits fiables, disponibles et adapt&eacute;s &agrave; vos
                besoins.
              </p>
              <ul>
                <li>Papeterie et consommables</li>
                <li>Mobilier et accessoires de bureau</li>
                <li>Gestion et suivi des commandes</li>
                <li>Livraison rapide et r&eacute;assort r&eacute;gulier</li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      {!embedded && <Footer />}
    </div>
  );
}

export default Services;

